export const states = ["NSW", "QLD", "SA", "Tas", "Vic", "WA", "ACT", "NT"];
